import styled from 'styled-components';
import Configuration from '../../../../configuration';

const ErrorDivComponent = styled.div`
  background: white;
  width: 100%;

  @media ${({ theme }) => theme.breakpoints.desktop} {
    width: 1240px;
    margin: 0 auto;
  }
`;

const Error404LogoComponent = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 50%;

  @media ${({ theme }) => theme.breakpoints.mobile} {
    width: 100%;
  }
`;

const WrapperImage = styled.img`
  width: 100%;
`;

const Error404Content = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 50%;
  @media ${({ theme }) => theme.breakpoints.mobile} {
    width: 100%;
  }
  text-align: center;
`;

const Error404Headline = styled.p`
  display: inline-block;
  position: relative;
  color: #527dc8;
  text-align: center;
  font-size: 32px;
  max-width: 400px;
  padding: 0 1rem;
`;

const Error404Button = styled.a`
  border: 0;
  background: #d6e5ff;
  color: #527dc8;
  font-size: 14px;
  box-shadow: none;
  display: inline-block;
  padding: 1rem;
  text-decoration: none;
  font-weight: 700;
  white-space: nowrap;
  line-height: 1;

  &:hover {
    text-decoration: underline;
  }
`;

export default function Error404() {
  return (
    <ErrorDivComponent>
      <Error404LogoComponent>
        <WrapperImage
          src={'https://currys-ssl.cdn.dixons.com/grafx/images/logos/e404.png'}
          alt={'404'}
        />
      </Error404LogoComponent>
      <Error404Content>
        <Error404Headline>
          <strong>Oops,</strong>
          {' '}
          the page you were looking for doesn&apos;t exist.
        </Error404Headline>
        <p>
          <Error404Button href={Configuration.get('site_url')}>
            Click here to get to the homepage &gt;
          </Error404Button>
        </p>
      </Error404Content>
    </ErrorDivComponent>
  );
}
